<template>
	<div v-if="componentData.data.hashtag == 1" class="text-center fs-5 p-4">
		<span @click="selectedHashtag = ''" :class="selectedHashtag === '' ? 'fw-bold' : ''">Összes</span>  |
		<span v-for="hashtag in hashtags">
			<span style="cursor:pointer;" @click="onFilterByHashtag(hashtag)" :class="selectedHashtag === hashtag ? 'fw-bold' : ''">{{ hashtag }} </span> |
		</span>
	</div>

	<div
			class="image-and-text-block__container"
			:class="[
      componentData.data.width === ComponentWidthEnum.FIX_1200 ? 'divider__fix-width' : '',
      'image-and-text-block__container--' + componentData.data.layout
    ]"
	>
		<template v-if="componentData.data.isSwiper == 0">
			<template v-for="(block, index) in componentData.data.blocks" :key="index">

				<div class="image-and-text-block__item mb-4" :style="{boxShadow: shadowState}" v-if="block.hashtag === selectedHashtag || selectedHashtag === ''">
					<div
							@click="block?.link ? openLink(block?.link) : null"
							class="image-and-text-block__image-container"
							:style="{
							backgroundImage: 'url(' + imagePath('path', block) + ')',
							backgroundSize: block.imageFit ?? 'cover',
							maxHeight: heightState,
							minHeight: heightState,
							cursor: block?.link ? 'pointer' : null,
						}"
					>
						<img v-if="block?.icon?.image || block.icon?.webp" :src="imagePath('icon', block)" alt="icon" class="image-and-text-block__icon" />
					</div>
					<div class="d-flex justify-content-between align-items-center px-3" :style="block?.link ? 'cursor:pointer;' : ''" @click="block?.link ? openLink(block.link) : null">
						<h3 v-if="block?.title" class="image-and-text-block__title" >{{ block.title }}</h3>
						<i v-if="block?.previewIcon"  :class="block?.previewIcon"></i>
					</div>
					<p v-if="block?.description" class="image-and-text-block__description" v-html="block.description"></p>
					<button-unit
							v-if="!!block.button?.text"
							class="image-and-text-block__button"
							@clickOnBtn="openLink(block.button.link)"
							:options="{
							text: block.button.text,
							type: 'button',
							shape: '',
							textColor: block.button.color,
							bgColor: block.button.background
						  }"
					/>
				</div>
			</template>
		</template>
		<template v-if="componentData.data.isSwiper == 1">
			<swiper
					:modules="[Navigation, Pagination]"
					:navigation="true"
					:pagination="{ clickable: true }"
					:space-between="20"
					:slides-per-view="slidesPerView"
					class="image-and-text-block__swiper"
			>
				<swiper-slide
						v-for="(block, index) in componentData.data.blocks"
						:key="index"
						class="image-and-text-block__item mb-4"
						:style="{
							boxShadow: shadowState,
						}"
				>
					<div
							class="image-and-text-block__image-container"
							:style="{
								backgroundImage: 'url(' + imagePath('path', block) + ')',
								backgroundSize: block.imageFit ?? 'cover',
								maxHeight: heightState,
								minHeight: heightState
							}"
					>
						<img v-if="block?.icon?.image || block.icon?.webp" :src="imagePath('icon', block)" alt="icon" class="image-and-text-block__icon" />
					</div>
					<div class="d-flex justify-content-between align-items-center px-3" :style="block?.link ? 'cursor:pointer;' : ''" @click="block?.link ? openLink(block.link) : null">
						<h3 v-if="block?.title" class="image-and-text-block__title" >{{ block.title }}</h3>
						<i v-if="block?.previewIcon"  :class="block?.previewIcon"></i>
					</div>
					<p v-if="block?.description" class="image-and-text-block__description" v-html="block.description"></p>
					<button-unit
							v-if="!!block.button?.text"
							class="image-and-text-block__button"
							@clickOnBtn="openLink(block.button.link)"
							:options="{
              text: block.button.text,
              type: 'button',
              shape: '',
              textColor: block.button.color,
              bgColor: block.button.background
            }"
					/>
				</swiper-slide>
			</swiper>
		</template>
	</div>
</template>

<style scoped lang="scss">
.image-and-text-block__swiper {
	width: 1200px;
	max-width: 1200px;
	box-sizing: border-box;
	padding: 0 10px;
}

.swiper-slide {
	flex-shrink: 0;
	width: auto !important;
	box-sizing: border-box;
}

/* Ha használod a box shadow-t */
.image-and-text-block__item {
	box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.12);
	overflow: hidden;
}
</style>

<script setup lang="ts">
import {computed, defineProps, PropType, ref} from "vue";
import { IImageAndTextBlockBoxComponent } from "@SharedInterfaces/ImageAndTextBlockComponent";
import ButtonUnit from "@/WebApp/Components/Units/ButtonUnit.vue";
import { ComponentWidthEnum } from "@SharedEnums/ComponentWidthEnum";
import { Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const props = defineProps({
	componentData: {
		type: Object as PropType<IImageAndTextBlockBoxComponent>,
		default: () => ({}),
		required: true,
	},
});

const imagePath = (property: string, image: any) => {
	return image[property]?.webp ?? image[property];
};

const openLink = (link: string) => {
	window.location.href = link;
};

const hashtags = computed(() =>
		[...new Set(props.componentData.data.blocks.map(block => block.hashtag))]
);
// Compute shadow style for reuse
const heightState = computed(() => {
	const height = props.componentData?.data?.height ?? 'auto';
	if(height !== 'auto') {
		return String(height + 'px');
	}
	return height;
});
const shadowState = computed(() => {
	if (props.componentData?.data?.shadow ?? true) {
		return "0px 4px 6px 0px rgba(0, 0, 0, 0.12)";
	}
	return "none";
});

const slidesPerView = computed(() => {
	const layout = props.componentData?.data?.layout;
	const numberLayout = typeof layout === "number" ? layout : parseInt(layout);
	return numberLayout && numberLayout > 0 ? numberLayout : 3;
});

const selectedHashtag = ref('');

const onFilterByHashtag = (hashtag) => {
	selectedHashtag.value = hashtag;
}
</script>
